import { render, staticRenderFns } from "./GameCardOrangeTheme.vue?vue&type=template&id=671b8828"
import script from "./GameCardOrangeTheme.vue?vue&type=script&lang=js"
export * from "./GameCardOrangeTheme.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports